export type ProjectRoute = {
  path: string;
  title: string;
  nextRoute?: keyof typeof PROJECT_ROUTES;
  prevRoute?: keyof typeof PROJECT_ROUTES;
};

export const PROJECT_ROUTES = {
  OVERVIEW: 'project-overview',
  SETUP: 'project-setup',
  EXISTING_DEBT: 'existing-debt',
  PROPOSAL: 'proposal',
  PROJECT_REVIEW: 'project-review',
} as const;

export const getProjectRoute = (projectId: string, route: keyof typeof PROJECT_ROUTES): string => {
  return `/projects/${projectId}/${PROJECT_ROUTES[route]}`;
};

export const PROJECT_ROUTE_CONFIG: Record<keyof typeof PROJECT_ROUTES, ProjectRoute> = {
  OVERVIEW: {
    path: PROJECT_ROUTES.OVERVIEW,
    title: 'Project Overview',
    nextRoute: 'SETUP',
  },
  SETUP: {
    path: PROJECT_ROUTES.SETUP,
    title: 'Project Setup',
    prevRoute: 'OVERVIEW',
    nextRoute: 'EXISTING_DEBT',
  },
  EXISTING_DEBT: {
    path: PROJECT_ROUTES.EXISTING_DEBT,
    title: 'Existing Debt',
    prevRoute: 'SETUP',
    nextRoute: 'PROPOSAL',
  },
  PROPOSAL: {
    path: PROJECT_ROUTES.PROPOSAL,
    title: 'Proposal Development',
    prevRoute: 'EXISTING_DEBT',
    nextRoute: 'PROJECT_REVIEW',
  },
  PROJECT_REVIEW: {
    path: PROJECT_ROUTES.PROJECT_REVIEW,
    title: 'Project Review',
    prevRoute: 'PROPOSAL',
  },
};
